import { Row, Col } from "antd";
import { useSelector } from "react-redux";
import MusicCard from "./musicCard";
import { sorttimestamp } from "../../../../assets/constants"
import styles from "./style.module.scss";

const MusicTab = () => {
  const { creditz = [] } = useSelector((state) => ({
    creditz: state.profile.creditz,
  }));

  return (
    <div className={styles.musicTab}>
      <Row justify="space-between" align="top">
        {creditz
          .filter((a) => a.trackName !== undefined && !a.hidden)
          .sort((a, b) => sorttimestamp(a,b))
          .map((music, index) => (
            <Col key={index}>
              <MusicCard music={music} />
            </Col>
          ))}
      </Row>
    </div>
  );
};

export default MusicTab;
